import React, { memo } from 'react';
import { PDFViewerProps } from '../types';
import { StyledPage } from './PDFViewerPage.styled';

interface PDFViewerPageProps {
	pageNumber: number;
	width: number;
	onClick?: PDFViewerProps['onPageClick'];
	pageStyle?: React.CSSProperties;
	renderTextLayer?: boolean;
	renderAnnotationLayer?: boolean;
	loader?: React.ReactElement;
	isPageSelected?: boolean;
}

export const PDFViewerPage = memo(
	({
		onClick,
		pageNumber,
		width,
		pageStyle,
		renderTextLayer,
		renderAnnotationLayer = false,
		loader,
		isPageSelected,
	}: PDFViewerPageProps) => {
		return (
			<StyledPage
				pageNumber={pageNumber}
				width={width}
				renderTextLayer={renderTextLayer}
				renderAnnotationLayer={renderAnnotationLayer}
				loading={loader}
				style={pageStyle}
				onClick={
					onClick
						? (event, page) => {
								onClick(pageNumber);
						  }
						: undefined
				}
				selected={isPageSelected}
			/>
		);
	}
);
